import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';


import { TransactionsContainerComponent } from './transactions.container';
import { TransactionsSummaryComponent } from './transactions-summary/transactions-summary.component';
import { TransactionsAccordionComponent } from './transactions-summary/transactions-accordion/transactions-accordion.component';
import { TransactionsDetailsComponent } from './transactions-details/transactions-details.component';
import { TransactionsEffects } from './transactions.effects';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from '../../global/pipes/pipes.module';
import { MobileCardComponent } from './mobile-card/mobile-card.component';
import { MobileOpeningCardComponent } from './mobile-opening-card/mobile-opening-card.component';
import { TableModule } from 'atlas-table';
import { CdkModule, DATE_FORMATS, DATE_LOCALE } from 'atlas-cdk';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { LegacyModule } from 'atlas-legacy';
import { FieldModule } from 'atlas-field';
import { PaginationModule } from 'atlas-pagination';
import { CardModule } from 'atlas-card';
import { AccordionModule } from 'atlas-accordion';
import { ModalModule } from 'atlas-modal';
import { TooltipModule } from 'atlas-tooltip';
import { MenuModule } from 'atlas-menu';
import { ListModule } from 'atlas-list';
import { LinkModule } from 'atlas-link';
export const COMPONENTS = [
  TransactionsContainerComponent,
  TransactionsSummaryComponent,
  TransactionsDetailsComponent,
  TransactionsAccordionComponent,
  MobileCardComponent,
  MobileOpeningCardComponent
];
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'd LLL yyyy', // 11 July 2025
  },
  display: {
    dateInput: { year: 'numeric', month: 'short', day: 'numeric' }, // e.g. Jul 11, 2025 with 'en-GB'
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PipesModule,
    CdkModule,
    TableModule,
    IconModule,
    ButtonModule,
    LegacyModule,
    FieldModule,
    PaginationModule,
    CardModule,
    AccordionModule,
    ModalModule,
    TooltipModule,
    MenuModule,
    ListModule,
    LinkModule,
    EffectsModule.forFeature([TransactionsEffects])
  ],
  exports: COMPONENTS,
  providers: [
    { provide: DATE_LOCALE, useValue: 'en-GB' },
    { provide: DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],
  bootstrap: [],
})
export class TransactionsModule {
}
